/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArchiveBoxIcon16Regular = forwardRef('ArchiveBoxIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M5.75 9a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5h-3A.75.75 0 0 1 5.75 9Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.25 2C1.56 2 1 2.56 1 3.25v2.5c0 .605.43 1.11 1 1.225v4.775A2.25 2.25 0 0 0 4.25 14h7.5A2.25 2.25 0 0 0 14 11.75V6.975c.57-.116 1-.62 1-1.225v-2.5C15 2.56 14.44 2 13.75 2H2.25ZM12.5 7h-9v4.75c0 .414.336.75.75.75h7.5a.75.75 0 0 0 .75-.75V7Zm1-1.5v-2h-11v2h11Z" })));
});
